import { colors } from "./colors";
import { borders } from "./borders";
import { fonts } from "./fonts";
import { media } from "./media";
import { charts } from "./charts";
import { palette } from "./palette";
import { headers } from "./headers";
import { ticket, modal } from "./elements";
export const MAXTheme = {
  colors,
  borders,
  fonts,
  media,
  charts,
  palette,
  ticket,
  modal,
  headers
};